import { useMemo } from "react";
import { graphql } from "react-relay";
import { useSubscriptionWithSkip } from "../utils/useSubscriptionWithSkip";
import { useWidgetSignalSubscriptionPublishedSubscription } from "./__generated__/useWidgetSignalSubscriptionPublishedSubscription.graphql";
import { useWidgetSignalSubscriptionArchivedSubscription } from "./__generated__/useWidgetSignalSubscriptionArchivedSubscription.graphql";

export function useWidgetSignalSubscription(
  teamIds: string[],
  _signalIds: string[],
  connection: string | undefined,
  interactive: boolean | undefined
) {
  useSubscriptionWithSkip<useWidgetSignalSubscriptionPublishedSubscription>(
    useMemo(
      () => ({
        variables: {
          teamIds,
          connections: connection ? [connection] : [],
        },
        subscription: graphql`
          subscription useWidgetSignalSubscriptionPublishedSubscription(
            $teamIds: [ID!]!
            $connections: [ID!]!
          ) {
            signalPublishedToStore(teamIds: $teamIds)
              @prependNode(
                connections: $connections
                edgeTypeName: "SignalEdge"
              ) {
              id
              ...SignalOverviewListItemMedium_Signal
            }
          }
        `,
      }),
      [teamIds, connection]
    ),
    {
      skip: teamIds.length === 0 || interactive === false,
    }
  );

  useSubscriptionWithSkip<useWidgetSignalSubscriptionArchivedSubscription>(
    useMemo(
      () => ({
        variables: { teamIds, connections: connection ? [connection] : [] },
        subscription: graphql`
          subscription useWidgetSignalSubscriptionArchivedSubscription(
            $teamIds: [ID!]!
            $connections: [ID!]!
          ) {
            signalArchivedAtStore(teamIds: $teamIds) {
              id @deleteEdge(connections: $connections)
            }
          }
        `,
      }),
      [teamIds, connection]
    ),
    {
      skip: teamIds.length === 0 || interactive === false,
    }
  );
}
